import SpendMapperLogo from "@/assets/logos/spendmapper"
import { ReactElement } from 'react';


export interface Option {
  name: string;
  permission: string;
  description: string;
  url: string;
  logo?: ReactElement;
  font?: string;
  new?: boolean
}

export const options: Option[] = [
  {
    name: "— CONNECT 2.0",
    url: "https://connect.dev.starcount.net",
    description: "BETA TESTING - Build custom audiences for insights, strategy, media planning and activation powered by the market’s best consumer geobehavioural datasets, for an ID-less and futureproofed targeting solution",
    permission: "portal:connect",
  },
  {
    name: "SpendMapper",
    url: "https://spendmapper.starcount.com",
    description: "Our spend intelligence platform reveals trends and insights across brands, competitors and categories so you can understand where customers spend their time and money, and benchmark your performance",
    permission: "portal:spendmapper",
    logo: <SpendMapperLogo />
  },
  {
    name: "supacharge",
    url: "https://social.dev.starcount.net",
    description: "Supacharge your social advertising performance through behavioural data-driven interest-based targeting",
    permission: "portal:social",
    font: 'comfortaa-bold',
  }
]

export const extraOptions: Option[] = [
  {
    name: "— CONNECT",
    url: "https://postcode.dev.starcount.net",
    description: "Build custom audiences for insights, strategy, media planning and activation powered by the market’s best consumer geobehavioural datasets, for an ID-less and futureproofed targeting solution",
    permission: "portal:postcode"
  },
  {
    name: "Profile",
    url: "https://profile.dev.starcount.net",
    description: "Understand our UK Customer Mindsets by deep-diving into their profiles to find out more about them and how best to utilise them in your marketing",
    permission: "portal:profile"
  },
  {
    name: "Map",
      url: "https://map.dev.starcount.net",
    description: "Visualise our Customer Mindsets and Interests mapped across the UK to build new audiences, profile customers, catchments and find lookalikes",
    permission: "portal:map"
  },
]


